import {ACCESS_LEVEL, PLATFORM_AREA} from '@advisor/util/constants';
// eslint-disable-next-line import/no-cycle
import store from '@advisor/store';
import exceptionHandler from '@advisor/util/exceptionHandler';
import {redirectToLogin} from '../interceptors';

export default {
  /**
   * check if visibility is allowed
   * @param {String?} platformArea
   * @param {Boolean?} viewOnly: false for controls, default otherwise
   *
   * @returns {boolean}
   */

  isVisible(platformArea = null, viewOnly = true) {
    if (platformArea === PLATFORM_AREA.COMMON) {
      return true;
    }

    const {platformAccess} = store?.state?.settings?.default;
    const accessLevel = typeof platformAccess === 'object' ? platformAccess[platformArea] : null;

    if (!accessLevel) {
      const err = new Error('Platform area not set in request');

      exceptionHandler.handleGenericException('accessLevel undefined', err);
      // redirecting to Log out after the Error: Platform area not set
      redirectToLogin();

      return false;
    }

    if (accessLevel === ACCESS_LEVEL.NO_ACCESS) {
      return false;
    }

    if (!viewOnly && [ACCESS_LEVEL.VIEW_ALL_CLIENTS, ACCESS_LEVEL.VIEW_PRIMARY_SHARED].includes(accessLevel)) {
      return false;
    }

    return true;
  },

  /**
   * Route guard version. Check if a view-only user can access the route
   * @param {*} _to
   * @param {*} _from
   * @param {*} next
   */
  clientViewOnlyCheck(_to, _from, next) {
    // get the permissions and redirect if view-only
    if (!this.isVisible(PLATFORM_AREA.CLIENTS, false)) {
      next({name: 'App404'});

      return false;
    }

    next();

    return true;
  },
};
